import {
  ApiChartAttribute,
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { Box, styled } from "@mui/material";
import AnalyticsChart from "features/analytics/components/AnalyticsChart";
import { IFromToChartOutput } from "Providers/FromToProvider";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { getSessionById } from "services/session";
import { TOP_BAR_HEIGHT } from "features/leftMenu/constants";

const StyledWrapper = styled(Box)(({ theme }) => ({
  height: `calc(100vh - ${TOP_BAR_HEIGHT}px - 120px)`,
  transform: "translate(-8px, -27px)!important",
  width: "calc(100% + 17px)",
  "& > .MuiBox-root": {
    height: "100%",
  },
}));

interface ITrafficTableProps {
  attributes?: ApiChartAttribute[];
  dateRange?: IFromToChartOutput;
  limit?: number;
}

function TrafficTable({ attributes, dateRange, limit }: ITrafficTableProps) {
  const history = useHistory();

  const onVisitClick = useCallback(
    async (v) => {
      const res = await getSessionById(Number(v));
      history.push(`../user-dashboard/${res.leadId}`);
    },
    [history]
  );

  return (
    <StyledWrapper>
      <AnalyticsChart
        forceNoComparison
        overrideDate={dateRange}
        onClick={{
          [ApiDimension.DIMENSION_SESSION_ID as string]: onVisitClick,
        }}
        chart={{
          name: "Traffic Report",
          dimension: [
            ApiDimension.DIMENSION_SESSION_START_DATE,
            ApiDimension.DIMENSION_SESSION_ID,
            ApiDimension.DIMENSION_LANDING_PAGE_FULL_URL,
          ],
          template: ApiChartTemplate.TABLE,
          type: ApiChartType.TABLE,
          orderBy: `${ApiDimension.DIMENSION_SESSION_START_DATE} desc`,
          attributes: attributes || [],
          yAxisKeys: [
            {
              key: "l",
              fields: [
                ApiMetric.METRIC_PAGEVIEWS_COUNT,
                ApiMetric.METRIC_AVERAGE_SESSION_DURATION,
                ApiMetric.METRIC_PAGE_MICRO_CONVERSIONS_COUNT,
                ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
                ApiMetric.METRIC_SALES_COUNT_LAST,
                ApiMetric.METRIC_REVENUE,
              ],
            },
          ],
          limit: limit,
          displayOptions: {
            noFilters: true,
            noTitle: true,
            noAttributionToggle: true,
            rowsPerPage: 20,
            tableColWidths: {
              [ApiDimension.DIMENSION_SESSION_ID]: 130,
              [ApiDimension.DIMENSION_SESSION_START_DATE]: 180,
              [ApiDimension.DIMENSION_LANDING_PAGE_FULL_URL]: 600,
            },
          },
        }}
      />
    </StyledWrapper>
  );
}

export default TrafficTable;
